import { Star, Quote } from "lucide-react";
import { Link } from "react-router-dom";

const FeaturedTestimonial = () => {
  return (
    <section className="py-12 bg-card">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          <Quote className="w-10 h-10 text-primary mx-auto mb-4 opacity-50" />
          
          <blockquote className="text-lg md:text-xl text-foreground leading-relaxed mb-6 italic">
            "The new wood floors completely transformed our cabin. Beautiful craftsmanship, clean work, and attention to detail that truly shows. Couldn't be happier with the result! Highly recommend Big Bear Pro Flooring. Very much appreciated!! 🥰"
          </blockquote>
          
          <div className="flex justify-center gap-1 mb-3">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="w-5 h-5 text-accent fill-accent" />
            ))}
          </div>
          
          <p className="font-heading font-bold text-foreground">
            — Nikki Bires-Jude
          </p>
          <p className="text-sm text-muted-foreground mb-4">
            Verified Facebook Review
          </p>
          
          <Link 
            to="/reviews"
            className="text-primary hover:text-primary/80 font-heading font-semibold text-sm transition-colors underline underline-offset-4"
          >
            Read more reviews →
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedTestimonial;
